<template>                
    <div class="mapContainer" style="height: 100%; width: 100%">
        <div class="row">
            <div class="col no-padding">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-primary btn-sm" @click="selectNone">{{ $t('common.actions.none') }}</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="selectAll">{{ $t('common.actions.all') }}</button>    
                </div>
            </div>
        </div>
        <div id="regions-map">
            
                <img id="background" :src="`${publicPath}/map/base.png`" style="width: 100%; height: 100%">
                
                <div v-for="region in availableRegions" :key="region.id" class="region" :style="`top: ${region.position.top}%; left: ${region.position.left}%; width: ${region.position.width}%`">
                    <img class="region-image" :src="resolveImage(region.standard, 'small')" @load="imageLoaded(region.standard)">
                    
                    <img class="region-image" v-show="region.value" :src="resolveImage(region.selected, 'small')">
                    
                    <transition name="fade">
                        <img class="region-image" v-show="region.isHovering" :src="resolveImage(region.hover, 'small')">
                    </transition>
                </div>
                
                <svg width="100%" height="100%" :viewBox="viewBox" v-if="regions">
                
                    <polygon 
                        v-for="region in availableRegions" 
                        :key="region.id"
                        class="polygon"
                        :points="computePoints(region.coordinates)"
                        @click="toggleSelected(region)"
                        @mouseover="mouseOver(region)"
                        @mouseleave="mouseLeave(region)"
                    />
                </svg>
        </div>
    </div>
</template>

<script>

export default {
    name: "ClickableMap",
    props: {
        regions: {
            type: Array,
            required: true,
            default: undefined
        }
    },
    computed: {
        availableRegions: {
            get() {
                return this.regions.filter(el => el.coordinates !== undefined);
            }, set(val) {
                this.emit('update:regions', val);
            }
        },
        viewBox: function() {
            let { x, y} = this.findMaximumValues();
            return `0 0 ${x} ${y}`;
        }
    },
    methods: {
        imageLoaded: function(image) {
            // console.log(`Loaded: ${JSON.stringify(image)}`)
        },
        mouseOver: function(region) {
            // Add the current region to the set of hovers
            this.$set(region, 'isHovering', true)
        },
        mouseLeave: function(region) {
            this.$set(region, 'isHovering', false)
        },
        // isHovering: function(region) {
        //     console.log("Calling is hovering for " + region.name);
        //     if (this.hover === undefined) {
                
        //         return false;
        //     }
        //     return this.hover.has(region.id);
        // },
        selectNone: function() {
            this.regions.map(el => {
                this.$set(el, 'value', false);
            });
        },
        selectAll: function() {
            this.regions.map(el => {
                this.$set(el, 'value', true);
            });
        },
        selectRegion: function(region) {
            this.$set(region, 'value', true);
        },
        toggleSelected: function(region) {
            this.$set(region, 'value', !region.value);
        },
        computePoints(coords) {
            let vals = "";
            let splitCoords = coords.split(",").map(el => parseInt(el));
            for (let i = 0; i < splitCoords.length; i += 2) {
                vals += `${splitCoords[i]},${splitCoords[i + 1]} `
            }
            return vals
        },
        findMaximumValues: function() {
            
            let x = -1;
            let y = -1
            for (let i = 0; i < this.regions.length; i++) {
                // For each of the regions, find the max
                let coordinates = this.regions[i].coordinates.split(",").map(el => parseInt(el));


                for (let j = 0; j < coordinates.length; j += 2) {
                    let cX = coordinates[j];
                    let cY = coordinates[j + 1];

                    if (cX > x) {
                        x = cX;
                    }

                    if (cY > y) {
                        y = cY;
                    }
                }

            }
            return { x, y };
        },
    },
    mounted() {
        this.hover = new Set();
    },
    data() {
        return {
            publicPath: process.env.VUE_APP_BASE_URL,
            hover: undefined
        }
    }
}
</script>

<style lang="scss" scoped>
$border-radius: 5px;
#regions-map {
    position: relative;
    display: inline-block; /* <= shrinks container to image size */
    margin-top: 12px;

    img {
        display: block;
        width: 100%;
        height: auto;
    }

    div {
        position: absolute;
    }

    svg {
        position: absolute;
        top: 0;
        left: 0;
    }
}

.polygon {
    fill: transparent;
    cursor: pointer;
}


.region {
    display: block;
    position: absolute;
}

.region-image {
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer; // This needs to be added, otherwise the pojnter disappears
}


.btn-group {
    width: 100%;
    z-index: 100;
    
    .btn {
        width: 100%;
        &:first-child {
            border-top-left-radius: $border-radius;
            border-bottom-left-radius: $border-radius;
        }

        &:last-child {
            border-top-right-radius: $border-radius;
            border-bottom-right-radius: $border-radius;
        }
    }
}

.no-padding {
    margin: 0;
    padding: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s
}

.fade-enter,
.fade-leave-to {
    opacity: 0
}


</style>